import { type FC, memo } from 'react';

import { OBJECT_TYPE_COLLECTIONS } from '@iconik-io/iconik-api/src/types/object_types';

import SearchPodAssetDetailed from './search_pod_asset_detailed';
import SearchPodCollectionDetailed from './search_pod_collection_detailed';
import type { SearchPodProps } from './types';

const SearchPod: FC<SearchPodProps> = (props) =>
  props.searchItem.object_type === OBJECT_TYPE_COLLECTIONS ? (
    <SearchPodCollectionDetailed {...props} />
  ) : (
    <SearchPodAssetDetailed {...props} />
  );

export default memo(SearchPod);
